/**
 * Link de inscripción de un torneo (torneos123.com/inscripcion/<slug>).
 *
 * El servidor lo arma con el nombre al crear el torneo (``_slugify`` en
 * backend/app/modules/tournaments/services.py) y ya no cambia aunque el
 * torneo se renombre. Si el link ya lo usa otro torneo, el servidor le
 * agrega «-» y 6 letras y números al azar (``_unique_slug``).
 *
 * La tabla de casos compartida con el servidor es
 * registrationLinkParityCases.json (revisión ronda 5 de «Duplicar torneo»).
 */

export const REGISTRATION_LINK_PREFIX = "torneos123.com/inscripcion/";

const SLUG_MAX_LEN = 200;

/** Igual que ``_slugify`` del servidor: minúsculas sin acentos y cualquier
 * otro signo (espacios, puntos, comas, guiones…) se vuelve un solo «-». */
export function registrationLinkSlug(name: string): string {
  let value = name.trim().toLowerCase().normalize("NFKD");
  value = value.replace(/[̀-ͯ]/g, "");
  value = value.replace(/ø/g, "o").replace(/æ/g, "ae").replace(/ß/g, "ss");
  value = value.replace(/[^a-z0-9]+/g, "-");
  value = value.replace(/^-+|-+$/g, "");
  if (!value) value = "tournament";
  return value.slice(0, SLUG_MAX_LEN);
}

/** Las letras que el servidor le agregó al link porque otro torneo ya lo
 * usaba (p. ej. «-956ed1»), o null si el link sale tal cual de este nombre
 * (o si el torneo se renombró y el link ya no sale de él). */
export function registrationLinkCollisionSuffix(slug: string, name: string): string | null {
  const base = registrationLinkSlug(name);
  if (slug === base) return null;
  const match = /^(.+)(-[0-9a-f]{6})$/.exec(slug);
  if (!match || match[1] !== base) return null;
  return match[2];
}
